import React, { Component } from 'react'
import Included from '../Included'
class BackToTop extends Component {

  constructor(props) {
    super(props)
  }

  render() {
    return(
      <section>
        <a className="anchor" id="backToTop"></a>
        <h2>Back To Top</h2>
        <p>An example of the "Back to Top" control can be seen in the bottom right-hand corner of this screen.</p>
        <p>Adding a "Back to Top" control can be achieved by adding the following JavaScript to your page:</p>
        <pre><code className="language-javascript">{`// JavaScript
commonUI.initializeBackToTop();`}</code></pre>
        <br/>
        <h3>Custom Margins</h3>
        <p>By default, the back to top control is placed 12 pixels from the bottom right-hand corner of the page,
        and will remain in this fixed position. In some circumstances, for example to allow for a bottom navigation bar,
        you can override the bottom and right offsets at initialization.</p>
        <pre><code className="language-javascript">{`// This will set the bottom margin to 50 pixels
commonUI.initializeBackToTop({ marginBottom: 50 });

// This will set the right margin to 30 pixels
commonUI.initializeBackToTop({ marginRight: 30 });

// This will set the bottom margin to 50 pixels and the right margin to 30 pixels
commonUI.initializeBackToTop({
  marginBottom: 50,
  marginRight: 30
});`}</code></pre>
        <br/>
        <hr/>
        <br/>
      </section>
    )
  }

}

export default BackToTop



// WEBPACK FOOTER //
// ./styleguide/components/sections/BackToTop.js